<template>
  <div>
    <div class="text-xs-right">
      <v-btn @click="showGroupDownload = true" color="grey" outline>
        <em class="fas fa-file-export" />
        &nbsp;
        {{ $t('export') }}&nbsp;
      </v-btn>
      <v-btn color="grey" outline @click="showSearch = true"
        ><v-icon>search</v-icon> {{ $t('Search') }}
        {{ search_array.length > 0 ? `(${search_array.length})` : '' }}</v-btn
      >
      <v-dialog v-model="showSearch" scrollable max-width="500px" persistent>
        <v-card>
          <!-- <v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showSearch = false"><v-icon>close</v-icon></v-btn>
          </v-card-title> -->
          <v-card-text>
            <div>ชื่อ - นามสกุล</div>
            <v-text-field
              name="name"
              single-line
              id="name"
              v-model="search.name"
              outline
              class="default-input"
            ></v-text-field>

            <div>เบอร์โทรศัพท์</div>
            <v-text-field
              name="tel"
              single-line
              id="tel"
              v-model="search.tel"
              outline
              class="default-input"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              outline
              color="grey"
              @click="
                search = {
                  name: '',
                  tel: ''
                }
                showSearch = false
                onSearch()
              "
              >Clear All</v-btn
            >
            <v-btn color="primary" @click="onSearch">{{ $t('Search') }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <Pagination
      v-model="page"
      :limit="limit"
      :total="total"
      :key="'top_pagination_' + timestamp"
      @onChange="onChange($event)"
    ></Pagination>
    <v-data-table
      :headers="headers"
      :pagination.sync="pagination"
      :items="data"
      class="elevation-1"
      hide-actions
      :loading="loading"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.tel }}</td>
          <td class="text-xs-center">{{ props.item.total }}</td>
          <td class="text-xs-center">{{ props.item.total_privilege }}</td>
          <td>
            <v-btn
              color="primary"
              small
              @click="
                customer = props.item
                showHistory = true
              "
            >
              ประวัติการอัปโหลดใบเสร็จ
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <Pagination
      v-model="page"
      :limit="limit"
      :total="total"
      :key="'bottom_pagination_' + timestamp"
      @onChange="onChange($event)"
    ></Pagination>

    <v-dialog v-model="showHistory">
      <template v-if="customer">
        <ReceiptHistory
          v-model="customer"
          @onClose="
            showHistory = false
            customer = null
          "
        ></ReceiptHistory>
      </template>
    </v-dialog>

    <ExportGroup
      v-model="showGroupDownload"
      @onExport="onExport"
      :total="total"
      filename="top_customer"
    ></ExportGroup>
  </div>
</template>

<script>
import Pagination from '@/components/elements/Pagination.vue'
import moment from 'moment'
import ReceiptHistory from './ReceiptHistory'
import exportxlsx2 from '@/components/elements/Exportxlsx2.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import ExportGroup from '@/components/elements/ExportGroup.vue'
export default {
  data() {
    return {
      customer: null,
      showHistory: false,
      showSearch: false,
      timestamp: moment().format('x'),
      headers: [
        {
          sortable: false,
          text: 'ลำดับ'
        },
        {
          value: 'name',
          text: 'ชื่อ-นามสกุล'
        },
        {
          value: 'tel',
          text: 'เบอร์โทรศัพท์'
        },
        {
          value: 'total',
          text: 'ยอดซื้อรวม',
          align: 'center'
        },
        {
          value: 'total_privilege',
          text: 'จำนวนสิทธิ์ทั้งหมด',
          align: 'center'
        },
        {
          sortable: false
        }
      ],
      data: [],
      total: 0,
      pagination: {
        rowsPerPage: -1,
        sortBy: 'total_privilege',
        descending: true
      },
      search: {
        name: '',
        tel: ''
      },
      limit: 25,
      offset: 0,
      page: 1,
      alldata: [],
      loading: true,
      showGroupDownload: false
    }
  },
  components: {
    Pagination,
    ReceiptHistory,
    exportxlsx2,
    ExportGroup
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    },
    search_array() {
      return Object.keys(this.search)
        .map((key) => (this.search[key] ? { name: key, value: this.search[key] } : null))
        .filter((el) => el)
    }
  },
  async mounted() {},
  methods: {
    async getTopCustomer(limit, offset) {
      const { sortBy, descending } = this.pagination

      let response = await api.getTopCustomer({
        pageid: this.selectedBot.pageid,
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null,
        limit: limit,
        offset: offset,
        sortBy: sortBy,
        descending: descending,
        ...this.search
      })
      return {
        total: response ? response.total : 0,
        data: response ? response.data : []
      }
    },
    async onExport(callback) {
      if (callback) {
        this.loading = true
        let { limit, offset } = callback
        let { data } = await this.getTopCustomer(limit, offset)
        let format_data = data.map((el) => {
          return {
            'ชื่อ-นามสกุล': el.name,
            เบอร์โทรศัพท์: el.tel,
            ยอดซื้อรวม: el.total,
            จำนวนสิทธิ์ทั้งหมด: el.total_privilege
          }
        })
        callback.submitData(format_data)
        this.loading = false
      }
    },
    async onChange(val) {
      this.loading = true
      let { data, total } = await this.getTopCustomer(val.limit, val.offset)
      this.total = total
      this.data = data
      this.loading = false
    },
    async onSearch() {
      this.loading = true
      let { data, total } = await this.getTopCustomer(this.limit, 0)
      this.total = total
      this.data = data
      this.page = 1
      this.timestamp = moment().format('x')
      this.showSearch = false
      this.loading = false
    }
  },
  watch: {
    async pagination() {
      this.loading = true
      let { data, total } = await this.getTopCustomer(this.limit, 0)
      this.total = total
      this.data = data
      this.page = 1
      this.timestamp = moment().format('x')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/TopCustomer.vue